<template>
  <div id="form-dados-pessoais" class="row mt-4">
    <div class="col-12">
      <form class="panel__content needs-validation" novalidate>
        <header class="panel__header mt-2">
          <h2 class="panel__title">
            NIF:
          </h2>
        </header>

        <div class="row">
          <p class="col-12 col-sm-6">
            <masked-input
              id="mask_cpf"
              v-validate="'required|nif'"
              type="text"
              name="cpf"
              class="form-control"
              v-model="user.cpf"
              :class="{ 'is-invalid': errors.has('cpf') }"
              :mask="[/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/,/\d/]"
              :guide="false"
              v-on:keydown.delete="onDeleteMask"
              @change="($event) => searchUserWithKey($event.target.value, '#modelIsCadSocio')"
              placeholder="000000000"
            >
            </masked-input>

            <span class="invalid-feedback"> {{ errors.first("cpf") }} </span>
          </p>
          <p class="col-12 col-sm-6">
            Através da validação do seu NIF, identificaremos se você já tem
            registo em nosso programa. Desta forma, daremos prosseguimento
            ao seu registo.
          </p>
        </div>

        <header class="panel__header mt-2">
          <h2 class="panel__title">DADOS PESSOAIS:</h2>
        </header>

        <div class="row">
          <p class="col-12 col-sm-6">
            <input
              :class="{ input: true, 'is-invalid': errors.has('nome') }"
              name="nome"
              v-validate="'required|alpha_spaces'"
              type="text"
              class="form-control"
              v-model="user.nome"
              id="nome"
              placeholder="Nome: João Paulo"
              value=""
            />
            <span class="invalid-feedback"> {{ errors.first("nome") }} </span>
          </p>
          <p class="col-12 col-sm-6">
            <input
              :class="{ input: true, 'is-invalid': errors.has('sobrenome') }"
              name="sobrenome"
              v-validate="'required|alpha_spaces'"
              type="text"
              class="form-control"
              v-model="user.sobrenome"
              id="sobrenome"
              placeholder="Sobrenome: da Silva"
              value=""
            />
            <span class="invalid-feedback">
              {{ errors.first("sobrenome") }}
            </span>
          </p>
        </div>

        <div class="row">
          <p class="col-12 col-sm-6">
            <input
              :class="{ input: true, 'is-invalid': errors.has('email') }"
              name="email"
              class="form-control"
              v-validate="'required|email_or_nif'"
              v-model="user.email"
              id="email"
              placeholder="E-mail:"
              @change="($event) => searchUserWithKey($event.target.value, '#modelIsCadSocioEmail')"
              value=""
            />
            <span class="invalid-feedback"> {{ errors.first("email") }} </span>
          </p>
          <p class="col-12 col-sm-6">
            <masked-input
              v-validate="'required|datanasc'"
              type="text"
              name="datanascimento"
              class="form-control"
              :class="{ 'is-invalid': errors.has('datanascimento') }"
              v-model="user.datanascimento"
              :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
              v-on:keydown.delete="onDeleteMask"
              :guide="false"
              placeholder="Data de Nascimento: DD/MM/AAAA"
            >
            </masked-input>

            <span class="invalid-feedback">
              {{ errors.first("datanascimento") }}
            </span>
          </p>
        </div>

        <div class="row">
          <p class="col-12 col-sm-6">
            <masked-input
              v-validate="'required|min:11'"
              type="text"
              name="celular"
              class="form-control"
              :class="{ 'is-invalid': errors.has('celular') }"
              v-model="user.celular"
              :mask="[/\d/,/\d/,/\d/,' ',/\d/,/\d/,/\d/,' ',/\d/,/\d/,/\d/]"
              v-on:keydown.delete="onDeleteMask"
              :guide="false"
              placeholder="Telemóvel: "
            >
            </masked-input>

            <span class="invalid-feedback">
              {{ errors.first("celular") }}
            </span>
          </p>
          <p class="col-12 col-sm-6">
            <select
              class="form-select"
              v-validate="'required'"
              v-model="user.sexo"
              :class="{ 'is-invalid': errors.has('sexo') }"
              name="sexo"
            >
              <option value="" selected disabled>Sexo:</option>
              <option v-if="plano['somente_feminino'] == 'N'" value="M">Masculino</option>
              <option value="F">Feminino</option>
            </select>

            <span class="invalid-feedback"> {{ errors.first("sexo") }} </span>
          </p>
        </div>

        <div class="row">
          <p class="col-12 col-sm-6">
            <input
              data-vv-as="senha"
              v-model="user.password"
              :class="{ 'is-invalid': errors.has('password') }"
              v-validate="'required|min:6|confirmed:password_confirm'"
              name="password"
              type="password"
              class="form-control"
              placeholder="Cria tua senha:"
            />

            <span class="invalid-feedback">
              {{ errors.first("password") }}
            </span>
          </p>
          <p class="col-12 col-sm-6">
            <input
              data-vv-as="confirma tua senha"
              v-model="user.password_confirm"
              :class="{ 'is-invalid': errors.has('password_confirm') || errors.has('password') }"
              v-validate="'required'"
              name="password_confirm"
              ref="password_confirm"
              type="password"
              class="form-control"
              placeholder="Confirma tua senha:"
            />

            <span class="invalid-feedback">
              {{ errors.first("password_confirm") }}
            </span>
          </p>
        </div>

        <div class="row">
          <div class="col-12 pt-5">
            <p>
              <input
                data-vv-as="termos de contrato"
                v-model="user.termoscontrato"
                :class="{ 'is-invalid': errors.has('termoscontrato') }"
                v-validate="'required'"
                name="termoscontrato"
                type="checkbox"
                class="form-check-input"
              />
              Li e aceito os
              <a
                href="#"
                data-bs-toggle="modal"
                style="color: blue"
                data-bs-target="#termosdecontratoModal"
                >termos de contrato</a
              >
              do programa.
              <span class="invalid-feedback">
                {{ errors.first("termoscontrato") }}
              </span>
            </p>
            <p>
              <input
                v-model="user.receberinfo"
                name="receberinfo"
                type="checkbox"
                class="form-check-input"
                checked="checked"
              />
              Aceito receber informativos do programa via e-mail e Whatsapp.
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <b-alert
              variant="danger"
              dismissible
              :show="error.show"
              v-model="error.show"
            >
              <div>{{ error.text }}</div>
            </b-alert>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  created() {
    console.log(this.$validator)
    this.$validator.localize('pt_PT')
  },
  data() {
    return {
      fields: [
        'nome',
        'twitter',
        'instagram',
        'sobrenome',
        'email',
        'cpf',
        'datanascimento',
        'celular',
        'sexo',
        'password',
        'password_confirm',
        'termoscontrato',
      ],
      error: {
        show: false,
        text: '',
      },
    }
  },
  props: {
    user: {
      required: true,
      type: Object
    },
    config: {
      required: true,
      type: Object
    },
    plano: {
      required: true,
      type: Object
    },
  },
  methods: {
    async submit() {
      try {
        if (await this.$validator.validateAll()) {
          return await this.storeUser()
        } else {
          throw new Error('Preencha os campos corretamente')
        }
      } catch (error) {
        $("html, body").animate({scrollTop:$("#cadastroSocio").offset().top - 10}, 500, 'swing');
        return false
      }
    },
    async searchUserWithKey(key, modalToOpen = '#modelIsCadSocio') {
      const response = await axios.get('/api/is_cad_socio/' + key)
      
      if(response.data > 0){
        $(modalToOpen).modal('show')
      }
    },
    async storeUser() {
      try {
        const response = await axios.post('/cadastro/dados-pessoais', {
          ...this.user,
          plano: this.plano
        })
        
        if(response.data.error && !response.data.usuario) {
          this.error.show = true
          this.error.text = response.data.message
          return false
        } else {
          this.user.id = response.data.data.id
          return true
        }
      } catch (error) {
        this.error.show = true
        console.log(error.response.data)
        if (typeof error.response.data.errors.email[0] !== 'undefined') {
          this.error.text = error.response.data.errors.email[0]
        } else {
          this.error.text = "Erro interno, tente novamente mais tarde."
        }
        
        return false
      }
    },
    // Não faço a menor ideia do que isso faz, originalmente foi escrito pelo David Petter.
    onDeleteMask(event) {
      let value = event.target.value; 
      let char = value[value.length-1];
      if (isNaN(parseInt(char)) || char == ' ') { event.target.value = value.substring(0, value.length-1); }
    }
  }
})
</script>